import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import GiftRow from '../Common/GiftRow'
import {
  DECORATION_DEFAULT_TEXT,
  DECORATION_NOTICE,
  NOTICE_REJECTED,
  NOTICE_VERIFYING
} from '@constant'
import { dGet } from '@core/utils'
import { Flex } from 'hljd'
import Arrow from '../Common/Arrow'
import {
  getNoticeGiftHonorTextColor,
  getNoticeIcon
} from '@components/LocalMerchant/Decoration/util'

@observer
export default class extends Component {
  getStatus = () => {
    const { allStatus } = this.props.store

    let status = ''

    const nStatus = dGet(allStatus, 'merchant_notice.status')

    if (nStatus == NOTICE_REJECTED) {
      status = 'rejected'
    } else if (nStatus == NOTICE_VERIFYING) {
      status = 'verifying'
    }

    return status
  }

  render() {
    const { store } = this.props
    const { mode, theme } = store
    const noticeStr = dGet(store, 'homeData.notice.content')

    const text = noticeStr || DECORATION_DEFAULT_TEXT[DECORATION_NOTICE]
    const status = this.getStatus()

    return mode === 'editable' || (mode === 'preview' && noticeStr) ? (
      <Rowbox
        type={DECORATION_NOTICE}
        store={store}
        style={{
          height: 'auto',
          minHeight: 75,
          padding: '0 16px',
          marginBottom: 0
        }}
        vCenter={false}
        status={status}
      >
        <GiftRow>
          <GiftRow.Title
            title={
              <div>
                <span style={{ marginRight: 5 }}>公告</span>
                <img
                  src={getNoticeIcon(theme)}
                  style={{ width: 13, height: 13 }}
                />
              </div>
            }
          />

          <Flex vc sp style={{ flex: 1, width: 0 }}>
            <div
              className="text-cut"
              style={{
                marginRight: 20,
                color: getNoticeGiftHonorTextColor(theme)
              }}
            >
              {text}
            </div>

            <Arrow />
          </Flex>
        </GiftRow>
      </Rowbox>
    ) : null
  }
}
